import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

function Navbar() {
  return (
    <header>
      <nav className="navbar">
          <ScrollLink activeClass="underline" to="about" spy={true} smooth={true} duration={500} offset={-200}>About</ScrollLink>
          <ScrollLink activeClass="underline" to="skills" spy={true} smooth={true} duration={500} offset={-200}>Experience</ScrollLink>
          <ScrollLink activeClass="underline" to="projects" spy={true} smooth={true} duration={500} offset={-200}>Projects</ScrollLink>
          <ScrollLink activeClass="underline" to="contact" spy={true} smooth={true} duration={500} offset={-200}>Contact</ScrollLink>
      </nav>
    </header>

  );
}

export default Navbar;
